import { createListenerMiddleware } from '@reduxjs/toolkit'
import { OFFER_COMPARISON_RESTORE_STATE } from 'actions/actionConstants'
import { storeComparisonState } from 'storage/offerComparison'

export const offerComparisonPersistenceMiddleware = createListenerMiddleware<App.State>()

offerComparisonPersistenceMiddleware.startListening({
  // Run on any change as checkout can be affected by many items in state
  predicate: (action, currentState, prevState) => {
    return currentState.offerComparison !== prevState.offerComparison &&
      action.type !== OFFER_COMPARISON_RESTORE_STATE
  },
  effect: async(_, listenerApi) => {
    const state = listenerApi.getState()
    storeComparisonState(state.offerComparison)
  },
})
